import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import OrderList from "../partials/list/OrderList";
import { BoxContainer } from '../layouts/Theme';
import { useFlow } from '../context/FlowContext';
import { useI18N } from '../context/I18NContext';
export default function Orders(props) {
    const { t } = useI18N();
    const flow = useFlow();
    // this view is outside the flow, so there is no step to take a label from: it puts its own
    // title in the app bar
    const title = t('Mijn bestellingen');
    useEffect(() => {
        var _a;
        (_a = flow.setTitle) === null || _a === void 0 ? void 0 : _a.call(flow, title);
    }, [title]);
    return (_jsx(BoxContainer, { children: _jsx(OrderList, {}) }));
}
